import React, { useState } from "react";
import Breadcrumb from "../../parts/Breadcrumb";
import { Link } from "react-router-dom";
import { pluck } from "underscore";
import ListSection from "../../components/ListSection";
import DeleteModel from "../../components/DeleteModel";
import labels from "../../constants/Driver";
import configuration from "../../config";
import { toast } from "react-toastify";

// List all Drivers
function View({ location }) {
  const columns = [
    {
      title: "ID",
      field: "id",
      render: (rowData) => (
        <Link
          className="text-indigo-600 hover:text-indigo-900"
          to={`/driver/edit/${rowData.user_id}`}
        >
          {rowData.user_id}
        </Link>
      ),
    },
    {
      title: "Name",
      field: "first_name",
      render: (rowData) => (
        <Link
          className="text-indigo-600 hover:text-indigo-900"
          to={`/driver/profile/${rowData.user_id}`}
        >
          {rowData.first_name} {rowData.last_name}
        </Link>
      ),
    },
    { title: "Email", field: "email" },
    {
      title: "Phone",
      field: "mobile",
      render: (rowData) => (
        <span>
          {rowData.mobile_country_code} {rowData.mobile}
        </span>
      ),
    },
    { title: "Sign up date", field: "created_at" },
    { title: "Wallet Balance", field: "wallet_balance" },
    {
      title: "Approval Status",
      field: "is_verified",
      render: (rowData) => (
        <span
          className={
            rowData.is_verified
              ? "inline-flex items-center px-3 py-0.5 rounded-full text-basefont-medium bg-green-100 text-green-800"
              : "inline-flex items-center px-3 py-0.5 rounded-full text-basefont-medium bg-red-100 text-red-800"
          }
        >
          {" "}
          {rowData.is_verified ? "Approved" : "Unapproved"}
        </span>
      ),
    },
    {
      title: "Availability Status",
      field: "availability_status",
      render: (rowData) => (
        <span
          className={
            rowData.availability_status === "online"
              ? "inline-flex items-center px-3 py-0.5 rounded-full text-basefont-medium bg-green-100 text-green-800 capitalize"
              : "inline-flex items-center px-3 py-0.5 rounded-full text-basefont-medium bg-red-100 text-red-800 capitalize"
          }
        >
          {" "}
          {rowData.availability_status}
        </span>
      ),
    },
    {
      title: "Status",
      field: "status",
      render: (rowData) => (
        <span
          className={
            rowData.status === "active"
              ? "inline-flex items-center px-3 py-0.5 rounded-full text-basefont-medium bg-green-100 text-green-800"
              : "inline-flex items-center px-3 py-0.5 rounded-full text-basefont-medium bg-red-100 text-red-800"
          }
        >
          {" "}
          {rowData.status === "active" ? "Active" : "Inactive"}
        </span>
      ),
    },
  ];

  const btnGroups = [
    { id: 1, title: "Add New", type: "addNew", path: "/driver/add" },
    { id: 4, title: "Approved", type: "makeApproved", path: "/driver" },
    { id: 5, title: "Unapproved", type: "makeUnapproved", path: "/driver" },
    { id: 2, title: "Make Active", type: "makeActive", path: "/driver" },
    { id: 3, title: "Make Inactive", type: "makeInactive", path: "/driver" },
    { id: 6, title: "Archive", type: "trashed", path: "/driver" },
    { id: 7, title: "Delete", type: "delete", path: "/driver" },
  ];

  const [showModal, setShowModal] = useState(false);
  const [ids, setIds] = useState([]);
  const tableRef = React.createRef();

  function handleAction(type) {
    if (ids.length < 1) {
      return toast.error("Please select at least one record");
    } else if (type === "delete") {
      setShowModal(true);
      return;
    }
    const sendData = {
      ids,
      type:
        type === "makeActive"
          ? "active"
          : type === "makeInactive"
          ? "inactive"
          : type === "makeApproved"
          ? "approved"
          : type === "makeUnapproved"
          ? "unapproved"
          : type,
    };
    configuration
      .postAPI({ url: "driver/action", params: sendData })
      .then((data) => {
        if (data.status === 200) {
          // getDatas({})
          tableRef.current.onQueryChange();
          setIds([]);
          return toast.success(
            type === "delete"
              ? "Record deleted successfully"
              : "Record updated successfully"
          );
        } else if (data.error) {
          return toast.error(data.error.message);
        } else {
          return toast.error("Something went wrong");
        }
      })
      .catch((error) => {
        return toast.error(error.message);
      });
  }
  const onSelectionChange = (e) => {
    let idArr = pluck(e, "user_id");
    setIds(idArr);
  };
  function handleDelete() {
    const sendData = {
      ids,
      type: "delete",
    };
    configuration
      .postAPI({ url: "driver/action", params: sendData })
      .then((data) => {
        if (data.status === 200) {
          // getDatas()
          tableRef.current.onQueryChange();
          setIds([]);
          setShowModal(false);
          return toast.success("Record deleted successfully");
        } else if (data.error) {
          return toast.error(data.error.message);
        } else {
          return toast.error("Something went wrong");
        }
      })
      .catch((error) => {
        return toast.error(error.message);
      });
  }
  function handleCancel() {
    setShowModal(false);
  }
  return (
    <>
      <Breadcrumb module={labels.Driver} />
      <DeleteModel
        mode={showModal}
        handleDelete={handleDelete}
        handleCancel={handleCancel}
      />
      <ListSection
        captionTitle="View Driver"
        columns={columns}
        tableRef={tableRef}
        // data={data}
        btnGroups={btnGroups}
        handleAction={handleAction}
        onSelectionChange={onSelectionChange}
        is_pagenation={true}
        apiURL="driver/list-new-sort"
      />
    </>
  );
}

export default View;
